module.exports = __webpack_public_path__ + "static/sunrise-background-85cfe3dc05382b2c44acbb4f05b93002.jpg";